module.exports = __webpack_public_path__ + "img/tl6.7db45cdc.webp";